import { FooterLayout, FooterSignalProps } from '@eventbrite/timed-entry';
import React, { FC } from 'react';
import { DiscountSvg } from '../../assests/DiscountSvg';
import styles from '../TimeSlotContainer.module.scss';

interface DiscountFooterProps {
    discount: string;
}

const DiscountFooter: FC<DiscountFooterProps> = ({ discount }) => {
    const footerSignals: FooterSignalProps[] = [
        {
            icon: <DiscountSvg />,
            // TODO: this is updated in time section PR(https://eventbrite.atlassian.net/browse/EB-297101), avoiding type error for now
            className: styles.footerSignal,
            text: discount,
        },
    ];

    return (
        <div className={styles.discountWrapper} data-testid="overall-discount">
            <FooterLayout footerMetaData={footerSignals} />
        </div>
    );
};

export default DiscountFooter;
